/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const LIST_ASSET = gql`
mutation Mutation($input: ListAssetInput) {
  listAssetToStore(input: $input) {
    token_id
    status
  }
}
  `

export const LIST_ASSET_RESELL_IN_CRYPTO = gql`
mutation ListForResellInCrypto($auth: AuthInput, $input: ListAssetInput, $tosInput:TOS) {
  listForResellInCrypto(auth: $auth, input: $input) {
    token_id
    token_group
    status
  }
  acceptTAndC(input: $tosInput) {
    accepted
  }
}
`

export const LIST_ASSET_RESELL_IN_FIAT = gql`
mutation ListForResellInFiat($auth: AuthInput, $input: ListAssetInput, $tosInput:TOS) {
  listForResellInFiat(auth: $auth, input: $input) {
    token_id
    token_group
    status
  }
  acceptTAndC(input: $tosInput) {
    accepted
  }
}
`


export const GET_RESELL_ASSET_VOUCHER= gql`
query GetResellVoucherToSign($auth: AuthInput!, $input: CreateVoucherInput!) {
  getResellVoucherToSign(auth: $auth, input: $input) {
    address
    payload
  }
}
`;